import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

import {Product} from "../../models/product";
import {ProductService} from "../../services/product/product.service";
import {RouterLink} from "@angular/router";
import {ProductNamePipe} from "../../pipes/product-name.pipe";

@Component({
  selector: 'app-open-products-teaser',
  imports: [
    RouterLink,
    ProductNamePipe
],
  templateUrl: './open-products-teaser.component.html',
  styleUrl: './open-products-teaser.component.scss'
})
export class OpenProductsTeaserComponent implements OnInit, OnChanges {

  @Input() limit?: number;
  @Input() householdId?: number;
  @Input() reloadToken?: number;

  products: Product[] = [];
  loading = false;

  constructor(private productService: ProductService) {
  }

  ngOnInit(): void {
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.limit || changes.householdId || changes.reloadToken) {
      this.load();
    }
  }

  private load(): void {
    const hid = this.householdId;
    if (hid == null) {
      this.products = [];
      this.loading = false;
      return;
    }

    this.loading = true;
    this.productService.getOpenProducts(hid, this.limit).subscribe({
      next: (prods) => {
        this.products = prods ?? [];
        if (this.limit && this.products.length > this.limit) {
          this.products = this.products.slice(0, this.limit);
        }
      },
      error: () => {
        this.products = [];
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  trackById(index: number, item: Product) {
    return item.id ?? index;
  }

}
